import { render, staticRenderFns } from "./AIConsult.vue?vue&type=template&id=1ab4e784&scoped=true&"
import script from "./AIConsult.vue?vue&type=script&lang=js&"
export * from "./AIConsult.vue?vue&type=script&lang=js&"
import style0 from "./AIConsult.vue?vue&type=style&index=0&id=1ab4e784&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab4e784",
  null
  
)

export default component.exports